module.exports = __webpack_public_path__ + "static/img/1.817d7b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/1.png
// module id = 9VbK
// module chunks = 0